import { FC } from 'react';
import { Button, Text, Modal, OverlayPortal, ColorPalettes } from '@morressier/ts';

const ActionModal: FC<{
  title: string;
  bodyText: string;
  acceptText: string;
  acceptAction: () => void;
  cancelText: string;
  cancelAction: () => void;
  acceptButtonColor?: ColorPalettes;
  loading?: boolean;
}> = props => {
  const {
    title,
    bodyText,
    acceptText,
    acceptAction,
    acceptButtonColor,
    loading,
    cancelText,
    cancelAction,
  } = props;

  return (
    <OverlayPortal>
      <Modal
        copies={{
          title,
        }}
        body={<Text>{bodyText}</Text>}
        close={cancelAction}
        footer={
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flex: '1 1 auto',
              minHeight: 32,
            }}
          >
            {cancelText && (
              <Button style={{ marginRight: '1rem' }} onClick={cancelAction}>
                {cancelText}
              </Button>
            )}

            <Button loading={loading} color={acceptButtonColor} onClick={acceptAction}>
              {acceptText}
            </Button>
          </div>
        }
      />
    </OverlayPortal>
  );
};

export default ActionModal;
